import { render } from "./BaseHeader.vue?vue&type=template&id=43bb27f9&scoped=true"
const script = {}

import "./BaseHeader.vue?vue&type=style&index=0&id=43bb27f9&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43bb27f9"]])

export default __exports__